module.exports = __webpack_public_path__ + "img/profile.542f6061.svg";